import { Tooltip } from '@affine/component';
import { OrgHubWordmark } from '@affine/component/orghub-brand';
import { useNavigateHelper } from '@affine/core/components/hooks/use-navigate-helper';
import { useI18n } from '@affine/i18n';
import { AuthService } from '@affine/core/modules/cloud';
import { NotificationBell } from '@affine/core/components/root-app-sidebar/notification-bell';
import { useLiveData, useService } from '@toeverything/infra';
import { type ButtonHTMLAttributes, useCallback } from 'react';

import { AppSidebarService } from '../../services/app-sidebar';
import { navHeaderStyle } from '../index.css';
import { SidebarSwitch } from './sidebar-switch';
import * as styles from './sidebar-switch.css';

export const SidebarLogoButton = ({
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement>) => (
  <button
    type="button"
    {...props}
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '4px 8px',
      borderRadius: 6,
      border: 'none',
      background: 'transparent',
      color: 'inherit',
      cursor: 'pointer',
      ...props.style,
    }}
  />
);

export const SidebarHeader = () => {
  const appSidebarService = useService(AppSidebarService).sidebar;
  const open = useLiveData(appSidebarService.open$);
  const sessionStatus = useLiveData(useService(AuthService).session.status$);
  const { jumpToIndex } = useNavigateHelper();
  const t = useI18n();

  const handleGoHome = useCallback(() => {
    // jumpToIndex navigates to '/', which renders the WorkspaceLandingPage
    // dashboard listing all workspaces.
    jumpToIndex();
  }, [jumpToIndex]);

  return (
    <div className={navHeaderStyle} data-open={open}>
      <div className={styles.sidebarHeaderLeft}>
        <SidebarSwitch show={open} />
        <Tooltip
          content={t['com.affine.sidebar.back-to-dashboard']()}
          side="right"
        >
          <SidebarLogoButton
            onClick={handleGoHome}
            data-testid="sidebar-logo-button"
            aria-label={t['com.affine.sidebar.back-to-dashboard']()}
            className="orghub-sidebar-logo"
          >
            <OrgHubWordmark size={15} />
          </SidebarLogoButton>
        </Tooltip>
      </div>
      <div className={styles.sidebarHeaderLeft}>
        {sessionStatus === 'authenticated' && <NotificationBell />}
      </div>
    </div>
  );
};

export * from './sidebar-switch';
